import { useStores } from '@littlebird/sdk';
import { useEffect, useRef } from 'react';

/**
 * Marks the report on screen as read, once per report. A failed write clears
 * the record so returning to the same report tries again.
 */
export const useMarkReportViewed = (referenceId: number | undefined): void => {
  const { reports } = useStores();
  const lastMarkedRef = useRef<number | null>(null);

  useEffect(() => {
    if (!referenceId || lastMarkedRef.current === referenceId) return;

    lastMarkedRef.current = referenceId;
    reports.markReportViewed(referenceId).catch(() => {
      lastMarkedRef.current = null;
    });
  }, [referenceId, reports]);
};
